import React, { ReactElement } from 'react';
import { useRouterUrl } from 'b2b-apps/shop/routes/hooks';
import { EnhancedComponentProps, EnhancedComponentType, WrappedComponentType } from './';

export const withContainer = (Component: WrappedComponentType): EnhancedComponentType => {
  const WithContainer = (props: EnhancedComponentProps): ReactElement => {
    const url = useRouterUrl();

    return <Component {...props} url={url} />;
  };

  return WithContainer;
};
